/* línkè · 聊天消息 API
   消息走 server-side（lingke_state.db 的 messages 表），跟记忆/日记同模式。
   localStorage 完全不缓存，避免双向同步竞态。
   2026-05-26: 所有调用挂到 conversation_id（多对话线） */

const BASE = '/api/messages';

async function jsonOrThrow(res) {
  const text = await res.text();
  let data;
  try { data = JSON.parse(text); } catch { throw new Error('non-JSON: ' + text.slice(0, 120)); }
  if (!res.ok) {
    const err = new Error(data.error || `HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}

/** 拉某条对话的全部消息。convId 必填（前端在没 convId 时自己选默认）。 */
export async function fetchMessages(convId) {
  if (!convId) throw new Error('fetchMessages requires convId');
  const res = await fetch(`${BASE}?conv=${encodeURIComponent(convId)}`, { credentials: 'include' });
  const data = await jsonOrThrow(res);
  return data.messages || [];
}

/** 单条 upsert。前端生成 id 保证幂等。必须带 conversation_id。 */
export async function pushMessage(msg, convId) {
  const payload = { ...msg };
  if (convId) payload.conversation_id = convId;
  const res = await fetch(BASE, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return jsonOrThrow(res);
}

export async function deleteMessage(id) {
  const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  return jsonOrThrow(res);
}

/** 清空某条对话的所有消息。convId 必填（防误删整库）。 */
export async function clearAllMessages(convId) {
  if (!convId) throw new Error('clearAllMessages requires convId');
  const res = await fetch(`${BASE}?conv=${encodeURIComponent(convId)}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  return jsonOrThrow(res);
}

/* 删除 id 以及之后所有（regenerate 用）。后端按消息所属对话内截断。 */
export async function truncateFrom(id) {
  const res = await fetch(`${BASE}/truncate-from/${encodeURIComponent(id)}`, {
    method: 'POST',
    credentials: 'include',
  });
  return jsonOrThrow(res);
}
